<template>
  <div>
    <div class="fade" v-show="showContractInfoBox">
    </div>
    <div class="succ-pop" v-show="showContractInfoBox" style="font-size: 14px;">
      <div class="mint-msgbox-wrapper" style="position: absolute; z-index: 100;">
        <div class="mint-msgbox">
          <div class="main-2_z">
            <div class="main2-title layer-fixed clearfix">
              <span class="fl"></span>
              <div style="margin-bottom: 20px;margin-left: 15px;padding-top: 10px">
                <div  style="width: 50%;float: left">{{type}}</div>
                <div style="width: 50%;float: left;text-align: right;color: #0a8ddf;" @click="actionHandler('cancel')"><span>关闭</span></div>
              </div >
              <div style="padding-top: 15px">
                <div class="xinxi" style="margin-left: 15px">
                  合同名称： {{contractInfo.contractName}}
                </div>
                <div class="xinxi">合同编号：    {{contractInfo.contractNo}}</div>
                <div class="xinxi">线下合同编号：{{contractInfo.contractNoOffline}}</div>
                <div class="xinxi">合同金额：    {{contractInfo.contractMoney}}</div>
                <div class="xinxi">付款方式： {{contractInfo.payTypeString}}</div>
                <div class="xinxi" v-if="(type==='交付明细'&& selected === '累计')||selected==='个人'">
                  合同是否结清账款：   {{contractInfo.isSettledString}}
                </div>
                <div class="xinxi"  v-if="(type==='交付明细'&& selected === '累计')||selected==='个人'">
                  未结清账款金额：   {{contractInfo.notSettledMoneySum}}
                </div>
                <div class="xinxi">业务员：    {{contractInfo.employeeName}}</div>
                <div class="xinxi">签署客户名称：   {{contractInfo.signedCustomerName}}</div>
                <div class="xinxi">签署客户单位：   {{contractInfo.signedEnterpriseName}}</div>
                <div class="xinxi">合同启动日期：   {{contractInfo.contractStartDT}}</div>
                <div class="xinxi">生产状态：   {{contractInfo.produceStatusString}}</div>
                <div class="xinxi">预计生产完结日期：   {{contractInfo.expectedProduceEndDT}}</div>
                <div class="xinxi">发货状态：    {{contractInfo.deliveryStatusString}}</div>
                <div class="xinxi">发货日期：    {{contractInfo.deliveryDT}}</div>
                <div class="xinxi"  v-if="type==='消费明细'&& selected!=='个人'">
                  待收账户余额 ：    {{contractInfo.waitPrepayAmount}}
                </div>
                <div class="xinxi"  v-if="type==='交付明细'&& selected!=='个人'">
                  待收尾款 ：    {{contractInfo.waitRetainage}}
                </div>
              </div>

            </div>
          </div>
<!--          <div class="mint-msgbox-btns">-->
<!--            <button class="mint-msgbox-btn mint-msgbox-cancel " @click="actionHandler('cancel')">取消</button>-->
<!--            <button class="mint-msgbox-btn mint-msgbox-confirm " @click="actionHandler('ok')">确定</button>-->
<!--          </div>-->
        </div>
      </div>
      <!--<div class="v-modal" style="z-index: 99;"></div>-->
    </div>
  </div>

</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  export default {
    name: 'contractInfoBox',
    props: ['contractInfo', 'type', 'selected'],
    data () {
      return {
        payType: ''
      }
    },
    computed: {
      ...mapState([
        'showContractInfoBox'
      ])
    },
    methods: {
      ...mapMutations(['SETCONTRCTINfFOBOX']),
      actionHandler (action) {
        if (action === 'cancel') {
          // this.resetWindow()
          this.SETCONTRCTINfFOBOX(false)
          return
        }
        if (action === 'ok') {
        }
      }
    }
}
</script>

<style scoped>

  .fade {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99;
  }

  /*弹出层*/
  .succ-pop{
    width: 300px;
    height: 380px;
    background: #fff;
    position: fixed;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -200px;
    z-index: 999;
    border-radius: 5px;
  }
  .succ-pop h3.title{
    text-align: center;
    font-size: 22px;
    color: #ce002c;
  }
  .xinxi {
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// ContractInfoBox.vue?9207f0ac